import { GameEventCommandKinds } from '../GameEventCommandKinds'
import { TableCommand } from './GameCommand'
import { ProcessableGameEventComamnd } from './ProcessableGameEventComamnd'

export class DoFoldForPlayerCommand extends ProcessableGameEventComamnd {
  constructor(
    public command: TableCommand,
    public gameId: string
  ) {
    super(command, gameId, GameEventCommandKinds.doFoldForPlayer)
  }
}
